import React from 'react'
import { Input, Select, Slider, Tooltip, Card } from 'antd'
import { InfoCircleFilled } from '@ant-design/icons'
import SceneTransition from './SceneTransition'
import Shot from './Shot'

const { TextArea } = Input

// Scene component abstracts a complete scene with its shots
const Scene = ({
  scene,
  transitions,
  formData,
  setScenes,
  isGeneratingAll = false,
  videoGenerating = [],
  handleRegenerateVideo,
  handleUploadVideo,
  handleEditSettings,
  handleTransitionSelect
}) => {
  const lastScene = formData.shotList[formData.shotList.length - 1]

  const isLastScene = lastScene && lastScene.id === scene.id

  return (
    <div className="scene-container">
      <div className="left-panel">
        <h2>
          {scene.title} ({scene.shots && scene.shots.length} shots)
        </h2>
        <TextArea
          value={scene.description}
          rows={2}
          disabled={isGeneratingAll || videoGenerating.includes(scene.id)}
          onChange={e => {
            const newDescription = e.target.value
            setScenes(prevScenes =>
              prevScenes.map(s =>
                s.id === scene.id ? { ...s, description: newDescription } : s
              )
            )
          }}
        />
      </div>

      <div className="right-panel">
        <div className="shots-grid">
          {/* Render all shots */}
          {scene.shots.map((shot, index) => (
            <Shot
              key={shot.id}
              shot={shot}
              sceneId={scene.id}
              index={index}
              isLastShot={index === scene.shots.length - 1}
              formData={formData}
              setScenes={setScenes}
              videoGenerating={videoGenerating}
              transitions={transitions}
              handleRegenerateVideo={handleRegenerateVideo}
              handleUploadVideo={handleUploadVideo}
              handleEditSettings={handleEditSettings}
              handleTransitionSelect={handleTransitionSelect}
              isGeneratingAll={isGeneratingAll}
            />
          ))}

          {!isLastScene && (
            <SceneTransition
              sceneId={scene.id}
              position="end"
              transitionType={transitions[`${scene.id}-end`]}
              handleTransitionSelect={handleTransitionSelect}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default Scene
